// extracted by mini-css-extract-plugin
module.exports = {"titleLabel":"components-pageTitle-pageTitle__titleLabel--1vhXS"};